






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'
import {InputTipoOcorrenciaSchema} from '@/schema/resource/TipoOcorrencia/InputTipoOcorrenciaSchema'

@Component
export default class PersistTipoOcorrenciaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTipoOcorrenciaSchema()
  tipoOcorrencia = new TipoOcorrencia()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.tipoOcorrencia.getTipoOcorrencia(id)
    }

    $.await.done('getTipoOcorrencia')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.tipoOcorrencia.persistTipoOcorrencia()
    await Helper.successAndPush(
      'system.success.persist',
      '/tipo-ocorrencia/list'
    )
  }
}
